import {Cookies} from 'react-cookie';
import {
    REPORTSUBJECT_RESET,
    REPORTSUBJECT_FOCUS,
    REPORTSUBJECT_DOWNLOADED,
    REPORTSUBJECTS_DOWNLOADED,
    REPORTSUBJECTS_PENDING,
    REPORTSUBJECTS_FAILED,
    REPORTSUBJECT_FAILED,
    REPORTSUBJECT_POSTING,
    REPORTSUBJECT_EDITING,
    REPORTSUBJECT_DELETING,
    REPORTSUBJECTS_RESET,
    REPORTSUBJECT_DELETED,
    REPORTSUBJECT_PICTURE_UPLOADING,
    REPORTSUBJECT_PICTURE_FAILED,
    REPORTSUBJECT_PICTURE_UPLOADED,
    REPORTSUBJECT_PICTURE_DELETING
} from './types';
import APIService from '../../services/api'
import {handleError} from '../infos/actions'

const cookies = new Cookies();

// Action creators

export const resetReportSubjectAction = () => {
    return {type: REPORTSUBJECT_RESET};
};

export const resetReportSubjectsAction = () => {
    return {type: REPORTSUBJECTS_RESET};
};

export const reportSubjectsPendingAction = () => {
    return {type: REPORTSUBJECTS_PENDING};
};

export const reportSubjectPostingAction = () => {
    return {type: REPORTSUBJECT_POSTING};
};

export const reportSubjectDeletedAction = (id) => {
    return {
        type: REPORTSUBJECT_DELETED,
        payload: id
    };
};

export const reportSubjectDeletingAction = () => {
    return {type: REPORTSUBJECT_DELETING};
};

export const reportSubjectEditingAction = () => {
    return {type: REPORTSUBJECT_EDITING};
};

export const reportSubjectsDownloadedAction = (types) => {
    return {
        type: REPORTSUBJECTS_DOWNLOADED,
        payload: types
    };
};

export const reportSubjectDownloadedAction = (type) => {
    return {
        type: REPORTSUBJECT_DOWNLOADED,
        payload: type
    };
};

export const reportSubjectFocusAction = (type) => {
    return {
        type: REPORTSUBJECT_FOCUS,
        payload: type
    };
};
export const uploadPictureAction = (picture) => {
    return {
        type: REPORTSUBJECT_PICTURE_UPLOADING,
        payload: picture
    };
};

export const uploadPictureFailedAction = (error) => {
    return {
        type: REPORTSUBJECT_PICTURE_FAILED,
        payload: error.message
    };
};

export const uploadPictureSucceedAction = (type) => {
    return {
        type: REPORTSUBJECT_PICTURE_UPLOADED,
        payload: type
    };
};

export const deletePictureAction = () => {
    return {
        type: REPORTSUBJECT_PICTURE_DELETING
    };
};

// Actions

export function resetReportSubject() {
    return (dispatch) => {
        dispatch(resetReportSubjectAction());
    }
}

export function resetReportSubjects() {
    return function (dispatch) {
        dispatch(resetReportSubjectsAction());
    }
}

export function getReportSubjects(appId) {
    return function (dispatch, getState) {
        dispatch(reportSubjectsPendingAction());
        return APIService
            .getReportSubjects(appId, cookies.get('token'))
            .then(reportSubjects => {
                dispatch(reportSubjectsDownloadedAction(reportSubjects));
            })
            .catch((error) => {
                dispatch(handleError(error, REPORTSUBJECTS_FAILED))
            });
    }
}

export function fetchReportSubject(appId, reportSubjectId) {
    return function (dispatch, getState) {
        let reportSubjects = getState().reportsubjects.content;
        let reportSubject = reportSubjects.find(function (reportSubject) {
            return reportSubject.id === reportSubjectId
        });

        if (reportSubject) {
            return dispatch(reportSubjectFocusAction(reportSubject));
        } else {
            return dispatch(getReportSubject(appId, reportSubjectId));
        }
    }
}

export function getReportSubject(appId, typeId) {
    return function (dispatch) {
        dispatch(reportSubjectsPendingAction());
        return APIService
            .getReportSubject(appId, typeId, cookies.get('token'))
            .then(reportSubject => {
                dispatch(reportSubjectDownloadedAction(reportSubject));
            })
            .catch((error) => {
                dispatch(handleError(error, REPORTSUBJECT_FAILED))
            });
    }
}

export function postReportSubject(appId, reportSubject) {
    return function (dispatch) {
        dispatch(reportSubjectPostingAction());
        return APIService
            .postReportSubject(appId, reportSubject, cookies.get('token'))
            .then(reportSubject => {
                dispatch(reportSubjectDownloadedAction(reportSubject));
            })
            .catch((error) => {
                dispatch(handleError(error, REPORTSUBJECT_FAILED))
            });
    }
}

export function putReportSubject(appId, reportSubject) {
    return function (dispatch) {
        dispatch(reportSubjectEditingAction());
        return APIService
            .putReportSubject(appId, reportSubject, cookies.get('token'))
            .then(reportSubject => {
                dispatch(reportSubjectDownloadedAction(reportSubject));
            })
            .catch((error) => {
                dispatch(handleError(error, REPORTSUBJECT_FAILED))
            });
    }
}

export function deleteReportSubject(appId, reportSubjectId) {
    return function (dispatch) {
        dispatch(reportSubjectDeletingAction());
        return APIService
            .deleteReportSubject(appId, reportSubjectId, cookies.get('token'))
            .then(() => {
                dispatch(reportSubjectDeletedAction(reportSubjectId));
            })
            .catch((error) => {
                dispatch(handleError(error, REPORTSUBJECT_FAILED))
            });
    }
}

export function postReportSubjectPicture(appId, reportSubjectId, picture, onUploadProgress = null) {
    return function (dispatch) {
        dispatch(uploadPictureAction(picture));
        return APIService
            .postReportSubjectPicture(appId, reportSubjectId, picture, cookies.get('token'), onUploadProgress)
            .then(reportSubject => {
                dispatch(reportSubjectDownloadedAction(reportSubject));
                dispatch(uploadPictureSucceedAction(reportSubject));
            })
            .catch((error) => {
                dispatch(handleError(error, REPORTSUBJECT_FAILED));
                dispatch(uploadPictureFailedAction(error));
            });
    }
}


export function deleteReportSubjectPicture(appId, reportSubjectId) {
    return function (dispatch) {
        dispatch(deletePictureAction());
        return APIService
            .deleteReportSubjectPicture(appId, reportSubjectId, cookies.get('token'))
            .then((reportSubject) => {
                dispatch(reportSubjectDownloadedAction(reportSubject));
            })
            .catch((error) => {
                dispatch(handleError(error, REPORTSUBJECT_FAILED))
            });
    }
}



// WEBPACK FOOTER //
// src/store/reportsubjects/actions.js